import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import {installApiPlugin} from "./plugins/api";

createInertiaApp({
    resolve: name => {
        return require(`./pages/${name}`).default;
    },
    setup({ el, App, props, plugin }) {
        if (el?.dataset?.page) {
            const pageData = JSON.parse(el.dataset.page);
            createApp({ render: () => h(App, props) })
                .use(plugin)
                .use(installApiPlugin({
                    baseUrl: pageData?.props.global.base_url,
                    endpoint: pageData?.props.global.api_endpoint,
                    laravelEndpoint: pageData?.props.global.laravel_api_endpoint,
                    featureFlags: pageData?.props.global.feature_flags,
                }))
                .mount(el)

        }


    },
})
